import { render, staticRenderFns } from "./instructionCategoryAction.vue?vue&type=template&id=173d779c"
import script from "./instructionCategoryAction.vue?vue&type=script&lang=js"
export * from "./instructionCategoryAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports